import * as React from 'react';

const FilterChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 19v2H6v-2H4v-2h2v-2h2v2h12v2H8zM18 13v2h-2v-2H4v-2h12V9h2v2h2v2zM8 7v2H6V7H4V5h2V3h2v2h12v2z"
        />
    </svg>
);

FilterChunkySvg.displayName = 'FilterChunkySvg';
export default FilterChunkySvg;
